<template>
  <main>
    <header>
      <h1>{{ title }}</h1>
    </header>
    <section v-if="posts">
      <post-item
        v-for="post in posts"
        :key="post.id"
        :post="post" />
      <pagination
        v-if="totalPages > 1"
        :total="totalPages"
        :current="page" />
    </section>
  </main>
</template>

<script setup>
import { ref, computed, onBeforeMount } from 'vue'
import { useStore } from '@/stores/main'
import PostItem from '@/components/template-parts/PostItem.vue'
import Pagination from '@/components/template-parts/PaginationItem.vue'

const store = useStore()
const props = [
  {
    page: {
      type: Number,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
  },
]

const postsRequest = ref({
  type: 'posts',
  params: {
    per_page: this.site.posts_per_page,
    page: props.page,
    tags: null,
  },
  showLoading: true,
})
const tagRequest = ref({
  type: 'tags',
  slug: props.slug,
})
const totalPages = ref(0)

const tag = computed(() => {
  return store.getCurrentSingleBySlug(tagRequest)
})
const posts = computed(() => {
  if (tag.value) {
    return store.requestedItems(postsRequest.value)
  }
  return []
})
const title = computed(() => {
  return `Archive for ${tag.value ? tag.value.name : ''}`
})

const getTag = () => {
  return store.getSingleBySlug(tagRequest.value).then(() => {
    setPostsRequestParams()
    store.updateDocTitle({
      parts: [tag.value.name, store.site.name],
    })
  })
}

const getPosts = () => {
  return store.getItems(postsRequest.value)
}

const setPostsRequestParams = () =>
  (postsRequest.value.params.tags = tag.value.id)
const setTotalPages = () =>
  (totalPages.value = store.getTotalPages(postsRequest.value))

onBeforeMount(() => {
  getTag()
    .then(() => getPosts())
    .then(() => setTotalPages())
})
</script>
